/**
 * Marcador de exportação Geppetto + aviso quando o HTML é servido no mod_resource padrão do Moodle.
 * Também helpers para auto-ajuste do iframe no recurso Arquivo (sem afetar mod_gepettoresource).
 */

function escHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function buildGeppettoExportWarningBanner(strings) {
  const title = strings?.modResourceWarningTitle ?? 'Conteúdo exportado pelo Geppetto';
  const body = strings?.modResourceWarningBody
    ?? 'Prefira usar o plugin Geppetto (mod_gepettoresource). No recurso padrão do Moodle você pode ter barra de rolagem dupla e perder outras melhorias. Baixe o plugin em geppetto.com. Este aviso aparece só para professores/editores — os alunos não o veem.';
  const link = strings?.modResourceWarningLink ?? 'https://geppetto.com';
  const linkLabel = strings?.modResourceWarningLinkLabel ?? 'Acessar dashboard Geppetto';
  const dismiss = strings?.modResourceWarningDismiss ?? 'Fechar aviso';

  return `<div id="geppetto-mod-resource-warning" class="geppetto-mod-resource-warning" role="status" aria-live="polite" data-geppetto-warning="1">
  <div class="geppetto-mod-resource-warning__inner">
    <span class="geppetto-mod-resource-warning__badge" aria-hidden="true">G</span>
    <div class="geppetto-mod-resource-warning__texts">
      <strong class="geppetto-mod-resource-warning__title">${escHtml(title)}</strong>
      <span class="geppetto-mod-resource-warning__body">${escHtml(body)}</span>
    </div>
    <a class="geppetto-mod-resource-warning__link" href="${escHtml(link)}" target="_blank" rel="noopener noreferrer">${escHtml(linkLabel)}</a>
    <button type="button" class="geppetto-mod-resource-warning__dismiss" aria-label="${escHtml(dismiss)}" title="${escHtml(dismiss)}">&times;</button>
  </div>
</div>`;
}

export const GEPPETTO_MOD_RESOURCE_WARNING_SCRIPT = `
<script data-geppetto-export-marker="1">
(function(){
  'use strict';
  function isGeppettoResourceModule(){
    try{
      if(window.geppettoMoodleWwwroot!=null&&String(window.geppettoMoodleWwwroot).trim()!=='')return true;
    }catch(e){}
    try{
      var p=window.parent&&window.parent.location&&window.parent.location.pathname;
      if(p&&/\\/mod\\/gepettoresource\\//.test(p))return true;
    }catch(e2){}
    return false;
  }
  function isMoodleResourceModule(){
    try{
      var p=window.parent&&window.parent.location&&window.parent.location.pathname;
      return !!(p&&/\\/mod\\/resource\\//.test(p));
    }catch(e3){}
    return false;
  }
  function isMoodleStaffViewer(){
    try{
      var doc=window.parent&&window.parent.document;
      if(!doc||!doc.body)return false;
      if(doc.body.classList.contains('editing'))return true;
      if(doc.querySelector('a[href*="modedit.php"], a[data-action="editsettings"], button[data-action="editsettings"], [data-key="editsettings"]'))return true;
      if(doc.querySelector('.activity-header [data-action="editsettings"], .activity-navigation [href*="modedit.php"]'))return true;
    }catch(e4){}
    return false;
  }
  function boot(){
    var bar=document.getElementById('geppetto-mod-resource-warning');
    if(!bar||!document.querySelector('[data-geppetto-export]'))return;
    if(isGeppettoResourceModule()){
      if(bar.parentNode)bar.parentNode.removeChild(bar);
      return;
    }
    if(window.self===window.top||!isMoodleResourceModule()||!isMoodleStaffViewer())return;
    bar.classList.add('is-visible');
    var btn=bar.querySelector('.geppetto-mod-resource-warning__dismiss');
    if(btn)btn.addEventListener('click',function(){
      bar.classList.remove('is-visible');
      bar.setAttribute('hidden','hidden');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();
</script>`;

/**
 * JS puro (sem <script>) injetado no resizer do export.
 * No mod_resource (mesma origem do Moodle), ajusta o iframe pai: altura do conteúdo,
 * largura 100% e remove borda. No mod_gepettoresource e no Visualizar do builder não faz nada.
 */
export const GEPPETTO_IFRAME_PARENT_FIT_JS = `
function geppettoIsPluginHost(){
  try{if(window.geppettoMoodleWwwroot!=null&&String(window.geppettoMoodleWwwroot).trim()!=='')return true;}catch(e0){}
  try{
    var p=window.parent&&window.parent.location&&window.parent.location.pathname;
    if(p&&/\\/mod\\/gepettoresource\\//.test(p))return true;
  }catch(e1){}
  return false;
}
/* Só no recurso Arquivo do Moodle — nunca no Visualizar do builder (senão trava scroll e esconde a paginação). */
function geppettoIsMoodleResourceHost(){
  try{
    var p=window.parent&&window.parent.location&&window.parent.location.pathname;
    return !!(p&&/\\/mod\\/resource\\//.test(p));
  }catch(e1b){}
  return false;
}
function geppettoFindOwnFrame(){
  try{if(window.frameElement)return window.frameElement;}catch(e2){}
  try{
    var doc=window.parent&&window.parent.document;
    if(!doc)return null;
    var list=doc.querySelectorAll('iframe');
    for(var i=0;i<list.length;i++){
      try{if(list[i].contentWindow===window)return list[i];}catch(e3){}
    }
  }catch(e4){}
  return null;
}
function geppettoApplyParentIframeFit(h,width){
  if(geppettoIsPluginHost())return;
  if(!geppettoIsMoodleResourceHost())return;
  var frame=geppettoFindOwnFrame();
  if(!frame)return;
  try{
    /* Defesa: iframe do modal Visualizar do Geppetto */
    var clsFrame=(frame.className&&String(frame.className))||'';
    if(/preview-device-iframe/.test(clsFrame))return;
    var hh=Math.max(1,Math.ceil(Number(h)||0));
    frame.style.setProperty('height',hh+'px','important');
    frame.style.setProperty('min-height',hh+'px','important');
    frame.style.setProperty('width','100%','important');
    frame.style.setProperty('max-width','100%','important');
    frame.style.setProperty('min-width','100%','important');
    frame.style.setProperty('border','0','important');
    frame.style.setProperty('border-width','0','important');
    frame.style.setProperty('outline','none','important');
    frame.style.setProperty('box-shadow','none','important');
    frame.style.setProperty('overflow','hidden','important');
    frame.setAttribute('scrolling','no');
    try{frame.removeAttribute('height');}catch(eR){}
    var node=frame.parentElement;
    for(var i=0;i<5&&node;i++){
      var cls=(node.className&&String(node.className))||'';
      if(/resourcecontent|resourcemediaplugin|resourceworkaround|activity-description|mod_resource/i.test(cls)||node.id==='resourceobject'){
        node.style.setProperty('border','0','important');
        node.style.setProperty('box-shadow','none','important');
        node.style.setProperty('outline','none','important');
        node.style.setProperty('overflow','visible','important');
        node.style.setProperty('padding','0','important');
      }
      node=node.parentElement;
    }
    var doc=frame.ownerDocument;
    if(doc&&!doc.getElementById('geppetto-mod-resource-fit-css')){
      var st=doc.createElement('style');
      st.id='geppetto-mod-resource-fit-css';
      st.textContent='#region-main iframe,.path-mod-resource iframe,.mod_resource iframe,.resourcecontent iframe,.resourcemediaplugin iframe{width:100%!important;max-width:100%!important;min-width:100%!important;border:0!important;box-shadow:none!important;outline:0!important}';
      (doc.head||doc.documentElement).appendChild(st);
    }
  }catch(e5){}
}
`;

export function buildGeppettoExportMarkerBundle(strings) {
  return buildGeppettoExportWarningBanner(strings) + GEPPETTO_MOD_RESOURCE_WARNING_SCRIPT;
}
